import React from 'react';
import LinkBranded, { LinkProps } from 'src/elements/links/2023_Q4/LinkBranded';
import { AppStoresLinksListContainer } from './AppStoresLinksList.styles';
import getButtonStyleByColorScheme from 'src/styles/functions/getButtonStyleByColorScheme';

interface AppStoresLinksList {
  colorScheme?: LinkProps['colorScheme'];
  colorSchemeVariant?: LinkProps['colorSchemeVariant'];
}

const AppStoresLinksList = ({
  colorScheme = 'LightTeal',
  colorSchemeVariant = 'tertiary',
}: AppStoresLinksList): JSX.Element => {
  const iconColor = getButtonStyleByColorScheme(
    colorScheme,
    colorSchemeVariant
  ).textColor;

  return (
    <AppStoresLinksListContainer>
      <LinkBranded
        colorScheme={colorScheme}
        text='App Store'
        url='https://itunes.apple.com/us/app/mighty-networks/id1081683081?mt=8'
        iconPosition='left'
        colorSchemeVariant={colorSchemeVariant}
        customBorderRadius={32}
        icon={
          <svg
            width='13'
            viewBox='0 0 13 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M10.4163 7.44517C10.4 5.67648 11.9016 4.81601 11.9703 4.77595C11.1198 3.56701 9.80167 3.40183 9.33845 3.38866C8.23134 3.27506 7.15744 4.03456 6.59347 4.03456C6.01825 4.03456 5.14978 3.39963 4.21378 3.41829C3.00929 3.4364 1.88249 4.11633 1.26449 5.17216C-0.0109146 7.32499 0.940288 10.4887 2.16222 12.2288C2.77346 13.081 3.48771 14.0326 4.42259 13.9991C5.33721 13.9624 5.67885 13.4306 6.78259 13.4306C7.87619 13.4306 8.19701 13.9991 9.15046 13.9777C10.1321 13.9624 10.7501 13.1217 11.3399 12.2617C12.0463 11.2849 12.33 10.3229 12.3412 10.2735C12.3181 10.2659 10.4349 9.56507 10.4163 7.44517Z'
              fill={iconColor}
            />
            <path
              d='M8.6152 2.24392C9.10712 1.64412 9.4437 0.828095 9.35027 0C8.63828 0.0307312 7.74786 0.480175 7.23511 1.06681C6.78146 1.58375 6.37621 2.43105 6.4809 3.22787C7.2807 3.28604 8.10189 2.8344 8.6152 2.24392Z'
              fill={iconColor}
            />
          </svg>
        }
      />
      <LinkBranded
        colorScheme={colorScheme}
        text='Play Store'
        url='https://play.google.com/store/apps/details?id=com.mightybell.mb&hl=en_US'
        iconPosition='left'
        colorSchemeVariant={colorSchemeVariant}
        customBorderRadius={32}
        icon={
          <svg
            width='13'
            viewBox='0 0 17 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M0.906764 17.6687C0.635575 17.5333 0.5 17.1947 0.5 16.8561C0.5 16.7884 0.5 16.653 0.5 16.5853C0.5 11.5743 0.5 6.5632 0.5 1.6199C0.5 1.34903 0.567788 1.14591 0.635575 0.875037C0.703402 0.739582 0.838977 0.604166 0.974591 0.46875C3.88981 3.38054 6.73724 6.29233 9.58467 9.20416C6.66945 11.9128 3.82202 14.7569 0.906764 17.6687Z'
              fill={iconColor}
            />
            <path
              d='M12.432 6.22336C11.6184 7.03597 10.7371 7.84855 9.92356 8.72887C7.21171 5.95249 4.43207 3.17612 1.72021 0.399739C1.72021 0.399739 1.72021 0.332031 1.788 0.332031C5.31342 2.29579 8.83881 4.2596 12.432 6.22336Z'
              fill={iconColor}
            />
            <path
              d='M1.72021 17.6689C4.43207 14.9603 7.21171 12.2516 9.92356 9.54297C10.6693 10.2878 11.4829 11.0327 12.3642 11.8453C8.83881 13.8091 5.31342 15.7729 1.788 17.6689H1.72021Z'
              fill={iconColor}
            />
            <path
              d='M12.8389 11.5729C11.9576 10.7603 11.1441 9.94767 10.2627 9.1351C11.1441 8.25478 12.0254 7.37446 12.9067 6.49414C13.1779 6.62956 13.4491 6.76501 13.7203 6.96814C14.3982 7.37446 15.144 7.71304 15.822 8.11933C16.0254 8.18703 16.161 8.32249 16.2965 8.52561C16.5677 8.86419 16.5677 9.20281 16.2965 9.54139C16.161 9.6768 16.0254 9.81226 15.822 9.87997C14.8728 10.4894 13.8559 11.0312 12.8389 11.5729Z'
              fill={iconColor}
            />
          </svg>
        }
      />
    </AppStoresLinksListContainer>
  );
};

export default AppStoresLinksList;
